import { useEffect, useContext, useState, useMemo } from 'react';
import MenuInformation from 'components/MenuManagement/MenuInformation';
import { loadMenu, sortByItemTypeOrdinal, hasRollOver } from 'helpers/menuPreview';
import ErrorBoundaryContext from 'context/ErrorBoundaryContext';

export default function useProvideMenuManagementMenuPreview() {
  const [isLoading, setIsLoading] = useState(true);
  const [addMainItem, setAddMainItem] = useState(null);
  const [hasError, setHasError] = useState(false);
  const [menu, setMenu] = useState(false);

  const {
    previewMenu: { menuUuid, merchantID, companyID },
  } = useContext(MenuInformation.Context);
  const { setError: setErrorBoundaryError } = useContext(ErrorBoundaryContext);

  useEffect(() => {
    const getMenu = async () => {
      setIsLoading(true);
      try {
        setMenu(
          await loadMenu({
            companyID,
            merchantID,
            menuID: menuUuid,
            setError: setErrorBoundaryError,
          }),
        );
      } catch (error) {
        setHasError(`An error occurred when loading ${menuUuid} - ${error}`);
      } finally {
        setIsLoading(false);
      }
    };
    getMenu();
  }, [companyID, merchantID, menuUuid, setErrorBoundaryError]);

  // eslint-disable-next-line no-shadow
  const getSortedChildren = ({ itemKey, itemType, childType, menu }) =>
    Object.keys(menu?.[childType] ?? {})
      .filter(
        child => menu?.[childType]?.[child]?.parentUuidId === menu?.[itemType]?.[itemKey]?.uuid,
      )
      .sort(sortByItemTypeOrdinal(menu, childType))
      .map(child => menu?.[childType]?.[child]);

  const menuHours = useMemo(() => {
    const values = {};
    (menu?.itemHours ?? []).forEach(({ dayIndex, startTime, endTime }) => {
      const menuHasRollover = hasRollOver(startTime, endTime);
      if (values[dayIndex]) {
        values[dayIndex].push({ startTime, endTime, menuHasRollover });
      } else {
        values[dayIndex] = [{ startTime, endTime, menuHasRollover }];
      }
    });
    return values;
  }, [menu]);

  return {
    isLoading,
    hasError,
    menu,
    addMainItem,
    setAddMainItem,
    menuHours,
    getSortedChildren,
  };
}
